import React, { Dispatch, SetStateAction } from 'react';
import { ProjectId } from 'api/models';
import { AddFormTemplatePopover } from 'components/organisms/forms/form-components';
import { useCreateTaskMutation } from 'queries';
import { useFormTemplatesListQuery } from 'queries/form-template';

export const AddFormPopover = ({
  visible,
  toggle,
  setTaskFormCreationInProgress,
  projectId,
  phaseId,
  onSubmit,
}: {
  visible: boolean;
  toggle: Dispatch<SetStateAction<boolean>>;
  setTaskFormCreationInProgress?: Dispatch<SetStateAction<boolean>>;
  projectId: number;
  phaseId?: number;
  onSubmit?: (name: string, id: number) => void;
}): JSX.Element => {
  const { data: formTemplates, isLoading: isFormTemplatesLoading } =
    useFormTemplatesListQuery();

  const { mutate } = useCreateTaskMutation(ProjectId(projectId));

  const createFormTask = (selectedFormTemplate: {
    label: string;
    value: number;
  }) => {
    if (onSubmit) {
      onSubmit(selectedFormTemplate.label, selectedFormTemplate.value);

      return;
    }
    const task = {
      taskName: selectedFormTemplate.label,
      formTemplateId: selectedFormTemplate.value,
      projectPhase: {
        projectPhaseId: phaseId,
      },
    };

    setTaskFormCreationInProgress?.(true);
    toggle(false);
    mutate(task, {
      onSettled: () => setTaskFormCreationInProgress?.(false),
    });
  };

  return (
    <AddFormTemplatePopover
      visible={visible}
      setVisible={toggle}
      formTemplates={formTemplates}
      isLoading={isFormTemplatesLoading}
      createForm={(v) => createFormTask(v)}
    />
  );
};
